<template>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1240 558" style="enable-background:new 0 0 1240 558;" xml:space="preserve">
<g id="FILL">
	<polygon id="_x34_01" class="svg-floorplate" points="759.04,405.53 822.66,405.53 822.66,290.94 756.6,290.94 756.6,343.76 596.32,343.76
		596.32,425.84 759.04,425.84 	"/>
	<polygon id="_x34_02" class="svg-floorplate" points="936.21,290.94 822.66,290.94 822.66,405.53 875.26,405.53 875.26,420.97 936.21,420.97
		"/>
	<polygon id="_x34_03" class="svg-floorplate" points="1106.87,438.87 1106.87,368.17 1071.92,368.17 1071.92,290.96 936.2,290.96
		936.2,423.43 959.77,423.43 959.77,438.87 	"/>
	<router-link :to="{ name: 'apartment', params: {apartment:  404}}">
		<polygon id="_x34_04" class="svg-transparent" points="1071.93,110.58 1071.93,182.9 1106.87,182.9 1106.87,255.23 1071.93,261.73
		936.21,261.73 936.21,126.83 959.78,126.83 959.78,110.58 	"/>
	</router-link>
	<polygon id="_x34_05" class="svg-floorplate" points="936.21,163.35 889.89,163.35 889.89,134.09 766.12,134.09 766.12,261.68 936.21,261.68
		"/>
	<polygon id="_x34_06" class="svg-floorplate" points="596.32,164.97 648.52,164.97 648.52,134 766.12,134 766.12,261.6 596.32,261.6 	"/>
	<a xlink:href="/apartment/407">
		<polygon id="_x34_07" class="svg-transparent" points="596.32,261.67 596.32,164.97 546.11,164.97 546.11,134.09 427.46,134.09 427.46,261.68
		"/>
	</a>
	<polygon id="_x34_08" class="svg-floorplate" points="258.43,261.58 258.43,163.35 307.99,163.35 307.99,134 427.4,134 427.4,261.6 	"/>
	<polygon id="_x34_09" class="svg-floorplate" points="195.05,150.44 258.44,150.44 258.44,261.68 126.78,261.68 126.78,233.24 142.22,233.24
		142.22,209.67 126.78,209.67 126.78,113.77 195.05,113.77 	"/>
	<polygon id="_x34_10" class="svg-floorplate" points="195.05,401.46 258.43,401.46 258.44,290.94 126.78,290.94 126.78,318.57 142.22,318.57
		142.22,343.76 126.78,343.76 126.78,438.84 195.05,438.84 	"/>
	<polygon id="_x34_11" class="svg-floorplate" points="425.83,418.53 425.83,290.94 258.44,290.94 258.43,388.46 305.56,388.46 305.56,418.53
		"/>
	<polygon id="_x34_12" class="svg-floorplate" points="546.11,395.77 596.32,395.77 596.32,290.94 425.83,290.94 425.83,418.53 546.11,418.53
		"/>
</g>
<g id="STROKES">
	<line class="st2" x1="125.04" y1="438.41" x2="936.49" y2="438.41"/>
	<line class="st2" x1="936.49" y1="118.23" x2="193.47" y2="118.23"/>
	<line class="st3" x1="126.78" y1="343.76" x2="126.78" y2="438.85"/>
	<line class="st3" x1="1071.93" y1="368.14" x2="1106.87" y2="368.14"/>
	<line class="st3" x1="1071.93" y1="290.94" x2="1071.93" y2="368.14"/>
	<line class="st3" x1="1071.93" y1="182.85" x2="1106.87" y2="182.85"/>
	<line class="st3" x1="1071.93" y1="110.52" x2="1071.93" y2="182.85"/>
	<line class="st3" x1="959.78" y1="422.59" x2="936.21" y2="422.59"/>
	<line class="st3" x1="959.78" y1="438.85" x2="959.78" y2="422.59"/>
	<line class="st3" x1="1106.87" y1="438.85" x2="959.78" y2="438.85"/>
	<line class="st3" x1="1106.87" y1="297.44" x2="1106.87" y2="438.85"/>
	<line class="st3" x1="1071.93" y1="290.94" x2="1106.87" y2="297.44"/>
	<line class="st3" x1="1071.93" y1="261.68" x2="1071.93" y2="290.94"/>
	<line class="st3" x1="1106.87" y1="255.18" x2="1071.93" y2="261.68"/>
	<line class="st3" x1="1106.87" y1="110.52" x2="1106.87" y2="255.18"/>
	<line class="st3" x1="959.78" y1="110.52" x2="1106.87" y2="110.52"/>
	<line class="st3" x1="959.78" y1="126.78" x2="959.78" y2="110.52"/>
	<line class="st3" x1="936.21" y1="126.78" x2="959.78" y2="126.78"/>
	<line class="st3" x1="889.89" y1="163.35" x2="936.21" y2="163.35"/>
	<line class="st3" x1="889.89" y1="134.09" x2="889.89" y2="163.35"/>
	<line class="st3" x1="766.12" y1="134.09" x2="889.89" y2="134.09"/>
	<line class="st3" x1="766.12" y1="261.68" x2="766.12" y2="118.65"/>
	<line class="st3" x1="648.52" y1="134.09" x2="766.12" y2="134.09"/>
	<line class="st3" x1="648.52" y1="164.97" x2="648.52" y2="134.09"/>
	<line class="st3" x1="596.32" y1="164.97" x2="648.52" y2="164.97"/>
	<line class="st3" x1="307.99" y1="134.09" x2="426.64" y2="134.09"/>
	<line class="st3" x1="307.99" y1="163.35" x2="307.99" y2="134.09"/>
	<line class="st3" x1="258.43" y1="163.35" x2="307.99" y2="163.35"/>
	<line class="st3" x1="427.46" y1="261.68" x2="427.46" y2="118.65"/>
	<line class="st3" x1="546.11" y1="164.97" x2="596.32" y2="164.97"/>
	<line class="st3" x1="546.11" y1="134.09" x2="546.11" y2="164.97"/>
	<line class="st3" x1="546.11" y1="395.77" x2="546.11" y2="418.53"/>
	<line class="st3" x1="596.32" y1="395.77" x2="546.11" y2="395.77"/>
	<line class="st3" x1="875.26" y1="420.97" x2="936.21" y2="420.97"/>
	<line class="st3" x1="936.21" y1="290.94" x2="936.21" y2="420.97"/>
	<line class="st3" x1="142.22" y1="343.76" x2="126.78" y2="343.76"/>
	<line class="st3" x1="142.22" y1="318.57" x2="142.22" y2="343.76"/>
	<line class="st3" x1="126.78" y1="318.57" x2="142.22" y2="318.57"/>
	<line class="st3" x1="142.22" y1="261.68" x2="142.22" y2="290.94"/>
	<line class="st3" x1="425.83" y1="418.53" x2="546.11" y2="418.53"/>
	<line class="st3" x1="305.55" y1="388.46" x2="258.43" y2="388.46"/>
	<line class="st3" x1="305.55" y1="418.53" x2="305.55" y2="388.46"/>
	<line class="st3" x1="425.83" y1="418.53" x2="305.55" y2="418.53"/>
	<line class="st3" x1="258.43" y1="290.94" x2="258.43" y2="438.85"/>
	<line class="st3" x1="195.04" y1="401.46" x2="258.43" y2="401.46"/>
	<line class="st3" x1="195.04" y1="438.85" x2="195.04" y2="401.46"/>
	<line class="st3" x1="126.78" y1="438.85" x2="936.21" y2="438.85"/>
	<line class="st3" x1="126.78" y1="290.94" x2="126.78" y2="318.57"/>
	<line class="st3" x1="593.87" y1="290.94" x2="124.33" y2="290.94"/>
	<line class="st3" x1="425.83" y1="438.85" x2="425.83" y2="290.94"/>
	<line class="st3" x1="427.46" y1="134.09" x2="546.11" y2="134.09"/>
	<line class="st3" x1="258.43" y1="118.65" x2="258.43" y2="261.68"/>
	<line class="st3" x1="195.04" y1="150.45" x2="258.43" y2="150.45"/>
	<line class="st3" x1="195.04" y1="113.77" x2="195.04" y2="150.45"/>
	<line class="st3" x1="126.78" y1="113.77" x2="195.04" y2="113.77"/>
	<line class="st3" x1="126.78" y1="209.67" x2="126.78" y2="113.77"/>
	<line class="st3" x1="142.22" y1="209.67" x2="126.78" y2="209.67"/>
	<line class="st3" x1="142.22" y1="233.24" x2="142.22" y2="209.67"/>
	<line class="st3" x1="126.78" y1="233.24" x2="142.22" y2="233.24"/>
	<line class="st3" x1="126.78" y1="261.68" x2="126.78" y2="233.24"/>
	<line class="st3" x1="822.66" y1="438.85" x2="822.66" y2="290.94"/>
	<line class="st3" x1="936.21" y1="438.85" x2="936.21" y2="420.97"/>
	<line class="st3" x1="936.21" y1="118.65" x2="195.04" y2="118.65"/>
	<line class="st3" x1="596.32" y1="261.68" x2="596.32" y2="118.65"/>
	<line class="st3" x1="1069.86" y1="261.68" x2="124.71" y2="261.68"/>
	<line class="st3" x1="756.61" y1="290.94" x2="1071.93" y2="290.94"/>
	<line class="st3" x1="756.61" y1="343.76" x2="596.32" y2="343.76"/>
	<line class="st3" x1="756.61" y1="290.94" x2="756.61" y2="343.76"/>
	<line class="st3" x1="596.32" y1="299.88" x2="756.61" y2="299.88"/>
	<line class="st3" x1="596.32" y1="438.85" x2="596.32" y2="290.94"/>
	<line class="st3" x1="759.04" y1="425.84" x2="596.32" y2="425.84"/>
	<line class="st3" x1="759.04" y1="405.53" x2="759.04" y2="425.84"/>
	<line class="st3" x1="875.26" y1="405.53" x2="759.04" y2="405.53"/>
	<line class="st3" x1="875.26" y1="420.97" x2="875.26" y2="405.53"/>
	<line class="st3" x1="936.21" y1="118.65" x2="936.21" y2="261.68"/>
	<line class="st3" x1="936.21" y1="290.94" x2="819.99" y2="290.94"/>
	<line class="st3" x1="822.66" y1="290.94" x2="822.66" y2="405.53"/>
	<line class="st3" x1="819.99" y1="405.53" x2="875.26" y2="405.53"/>
	<line class="st3" x1="875.26" y1="405.53" x2="875.26" y2="420.97"/>
	<line class="st3" x1="875.26" y1="420.97" x2="936.21" y2="420.97"/>
	<path class="st3" d="M936.21,290.94"/>
	<path class="st3" d="M936.21,420.97"/>
</g>
<g id="KEY_FRAME">
	<path class="st3" d="M1071.93,261.68"/>
	<polyline class="st4" points="1071.93,261.68 1071.93,290.94 1106.87,297.44 1106.87,438.85 959.78,438.85 959.78,422.59
		936.21,422.59 936.21,438.85 126.78,438.85 126.78,343.76 142.22,343.76 142.22,318.57 126.78,318.57 126.78,290.94 142.22,290.94
		142.22,261.68 126.78,261.68 126.78,233.24 142.22,233.24 142.22,209.67 126.78,209.67 126.78,113.77 195.04,113.77 195.04,118.65
		936.21,118.65 936.21,126.78 959.78,126.78 959.78,110.52 1106.87,110.52 1106.87,255.18 1071.93,261.68 	"/>
</g>
</svg>

</template>

<script>
export default {

}
</script>

<style>
	.st2{fill:none;stroke:#1D1D1B;stroke-width:1.5733;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st3{fill:none;stroke:#1D1D1B;stroke-width:1.5694;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st4{fill:none;stroke:#231F20;stroke-width:6.1956;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}

</style>